<template>
  <div class='modal-container' style='width: 450px;'>
    <div class="modal-header fl">
      <h3>Reeds Actieve Ziekmelding</h3>
    </div>

    <div class='modal-body hf'>
      <p class='mb-4'>
        De werknemer die u probeert te selecteren heeft al een actieve ziekmelding.
        U kunt daarom geen nieuwe ziekmelding voor de werknemer aanmaken.</p>

      <v-divider />
      <div class='modal-link' @click="this.handleNavigateToReportOfSickness">
        <v-icon class='icon'>chevron_right</v-icon>
        <p>De actieve ziekmelding wijzigen</p>
      </div>
    </div>

    <div class='modal-footer'>
      <Button gray @click="this.handleClose" style='float: right;'>{{ 'buttons.close' | translate }}</Button>
      <div style='clear: both;' />
    </div>
  </div>
</template>

<script>
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import Modal from '@/shared/constants/modal';

import AppConstants from '@/views/constants/app-navigation';
import NewReportOfSicknessConstants from '@/views/constants/report-of-sickness-new';
import ReportsOfSicknessConstants from '@/views/constants/reports-of-sickness';

export default {
  name: 'AlreadyHasActiveReportOfSickness',
  components: {
    Button
  },
  props: {
    modalData: null
  },
  methods: {
    handleClose () {
      this.$store.dispatch(Modal.Actions.CLOSE);
    },
    handleNavigateOverview () {
      this.$store.dispatch(Modal.Actions.CLOSE)
        .then(this.$store.dispatch(NewReportOfSicknessConstants.Actions.Cancel.DO))
        .then(this.$store.dispatch(ReportsOfSicknessConstants.Actions.Tabs.OPEN, this.$store.getters.reportsOfSicknessTabs.find(tab => tab.component === 'ReportsOfSicknessIndex'))
          .then(this.$store.dispatch(AppConstants.Actions.Navigate.DO, AppConstants.Views.ReportsOfSickness))
          .then(window.scroll(0, 0)));
    },
    handleNavigateToReportOfSickness () {
      this.$store.dispatch(Modal.Actions.CLOSE)
        .then(this.$store.dispatch(NewReportOfSicknessConstants.Actions.Cancel.DO))
        .then(this.$store.dispatch(ReportsOfSicknessConstants.Actions.Tabs.OPEN_DETAILS, {
          employee: this.modalData.employee,
          reportOfSickness: this.modalData.reportOfSickness
        }))
        .then(this.$store.dispatch(AppConstants.Actions.Navigate.DO, AppConstants.Views.ReportsOfSickness))
        .then(window.scroll(0, 0));
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.theme--light.v-divider {
  border-color: $gray-lighten-3;
}
</style>
